/**
 * Service Types API service
 * Read-only — the backend does not expose write operations for service-types
 */

import { httpClient } from '@/utils/httpClient';
import type {
    APIServiceType,
    DRFPaginatedResponse,
} from '@/types';

/**
 * API endpoint for service types
 */
const BASE_ENDPOINT = '/service-types/';

const byId = (id: number): string => `${BASE_ENDPOINT}${id}/`;

/**
 * Query params accepted by the list endpoint
 */
export interface ServiceTypesListParams {
    page?: number;
    page_size?: number;
}

/**
 * Service types service implementation (read-only)
 */
export const serviceTypesService = {
    /**
     * Get paginated list of service types
     */
    async list(
        params?: ServiceTypesListParams
    ): Promise<DRFPaginatedResponse<APIServiceType>> {
        const searchParams = new URLSearchParams();

        if (params?.page !== undefined) {
            searchParams.set('page', String(params.page));
        }
        if (params?.page_size !== undefined) {
            searchParams.set('page_size', String(params.page_size));
        }

        const queryString = searchParams.toString();
        const endpoint = queryString
            ? `${BASE_ENDPOINT}?${queryString}`
            : BASE_ENDPOINT;

        return httpClient.get<DRFPaginatedResponse<APIServiceType>>(endpoint);
    },

    /**
     * Get a single service type by ID
     */
    async getById(id: number): Promise<APIServiceType> {
        return httpClient.get<APIServiceType>(byId(id));
    },
};

export default serviceTypesService;
